import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
} from '@material-ui/core';
import { map } from 'lodash';
import styled from 'styled-components';
import { em } from 'polished';
import { appTheme } from '../../../theme';
import { mediaQuery, Container, PageHeader } from '../../common';
import { COLUMNS } from '../constants';
import UserDetails from './UserDetails';

const HeadingTableCell = styled(TableCell)`
  background-color: ${appTheme.system.title};
  color: ${appTheme.system.white};
`;

const Head = styled(TableHead)`
  display: none;

  ${mediaQuery.xlarge`
    display: table-header-group;
  `};
`;

const TableContainer = styled(Paper)`
  margin-top: ${em(appTheme.spacing.xlarge)};
`;

class UserManagementPage extends React.Component {
  static propTypes = {
    onChangeStatus: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onMount: PropTypes.func.isRequired,
    users: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.props.onMount();
  }

  render() {
    const { onChangeStatus, onDelete, users } = this.props;

    return (
      <Container>
        <PageHeader title="User Management" />
        <TableContainer>
          <Table>
            <Head>
              <TableRow>
                {COLUMNS.map(heading => (
                  <HeadingTableCell key={heading}>{heading}</HeadingTableCell>
                ))}
                <HeadingTableCell />
              </TableRow>
            </Head>
            <TableBody>
              {map(users, user => (
                <UserDetails
                  {...user}
                  key={user.id}
                  onChangeStatus={onChangeStatus}
                  onDelete={onDelete}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    );
  }
}

export default UserManagementPage;



// WEBPACK FOOTER //
// ./src/modules/UserManagement/components/UserManagementPage.js